import { client } from '@/client';

// 发送数据
export function sendMessage(params) {
  return client.post('/api/console/topic/send', params);
}
